import React, { useState } from 'react';
import { LogOut, Home as HomeIcon } from 'lucide-react';
import HeroTab from '@/admin/tabs/HeroTab';
import ExperiencesTab from '@/admin/tabs/ExperiencesTab';
import SpeakersTab from '@/admin/tabs/SpeakersTab';
import FeaturedSessionTab from '@/admin/tabs/FeaturedSessionTab';
import FastTrackTab from '@/admin/tabs/FastTrackTab';
import RegistrationTab from '@/admin/tabs/RegistrationTab';
import PartnersTab from '@/admin/tabs/PartnersTab';
import GalleryTab from '@/admin/tabs/GalleryTab';
import FooterSettingsTab from '@/admin/tabs/FooterSettingsTab';
import MotionVisualTab from '@/admin/tabs/MotionVisualTab';
import SiteSettingsTab from '@/admin/tabs/SiteSettingsTab';
import StubRoutesTab from '@/admin/tabs/StubRoutesTab';
import FAQTab from '@/admin/tabs/FAQTab';
import NewsTab from '@/admin/tabs/NewsTab';
import GalleryEventsTab from '@/admin/tabs/GalleryEventsTab';
import UpcomingEventsTab from '@/admin/tabs/UpcomingEventsTab';
import PresentingSponsorTab from '@/admin/tabs/PresentingSponsorTab';

const TABS = [
  { key: 'hero', label: 'Hero', Component: HeroTab },
  { key: 'upcoming-events', label: 'Upcoming Events', Component: UpcomingEventsTab },
  { key: 'experiences', label: 'Experiences', Component: ExperiencesTab },
  { key: 'speakers', label: 'Speakers', Component: SpeakersTab },
  { key: 'featured', label: 'Featured Session', Component: FeaturedSessionTab },
  { key: 'fast-track', label: 'Fast Track', Component: FastTrackTab },
  { key: 'registration', label: 'Registration', Component: RegistrationTab },
  { key: 'presenting-sponsor', label: 'Presenting Sponsor', Component: PresentingSponsorTab },
  { key: 'partners', label: 'Partners', Component: PartnersTab },
  // Visible labels only — keys, components, routes and collections
  // keep their original names.
  { key: 'gallery', label: 'Gallery Photos', Component: GalleryTab },
  { key: 'gallery-events', label: 'Gallery Filters', Component: GalleryEventsTab },
  { key: 'footer', label: 'Footer & Settings', Component: FooterSettingsTab },
  { key: 'motion', label: 'Motion & Visual', Component: MotionVisualTab },
  { key: 'site', label: 'Site Settings', Component: SiteSettingsTab },
  { key: 'stubs', label: 'Stub Routes', Component: StubRoutesTab },
  { key: 'news', label: 'News', Component: NewsTab },
  { key: 'faq', label: 'FAQ', Component: FAQTab },
];

export default function AdminDashboard({ onLogout }) {
  const [active, setActive] = useState('hero');
  const Active = TABS.find((t) => t.key === active)?.Component || HeroTab;

  return (
    <div className="min-h-screen bg-bg-canvas" data-testid="admin-dashboard">
      <header className="sticky top-0 z-40 bg-bg-canvas border-b border-border-line">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 h-[64px] flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-sm bg-brand-orange flex items-center justify-center">
              <span className="font-display font-bold text-white text-[12px] leading-none">SIII</span>
            </div>
            <div className="leading-tight">
              <div className="font-display font-bold uppercase text-ink-primary text-[14px] tracking-tightish">SEICON III Admin</div>
              <div className="font-body text-[10px] uppercase text-ink-soft tracking-wider3" data-testid="admin-build-label">Build seicon-iii-homepage-gallery-v3.16</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <a href="/" className="btn-secondary !py-2 !px-3 text-[11px]" data-testid="view-site"><HomeIcon size={14} className="mr-1" /> View Site</a>
            <button onClick={onLogout} className="btn-secondary !py-2 !px-3 text-[11px]" data-testid="logout"><LogOut size={14} className="mr-1" /> Logout</button>
          </div>
        </div>
      </header>

      <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-6 md:py-8 grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-6">
        <aside className="lg:sticky lg:top-[80px] lg:self-start">
          <nav className="flex lg:flex-col gap-1 overflow-x-auto no-scrollbar bg-bg-elevated border border-border-line rounded-md p-2">
            {TABS.map((t) => (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                className={
                  'shrink-0 text-left font-body font-semibold text-[12px] uppercase tracking-wider2 px-3 py-2.5 rounded-sm transition ' +
                  (active === t.key ? 'bg-ink-primary text-white' : 'text-ink-primary hover:bg-bg-canvas')
                }
                data-testid={`tab-${t.key}`}
              >
                {t.label}
              </button>
            ))}
          </nav>
        </aside>

        <section className="bg-bg-elevated border border-border-line rounded-md p-5 md:p-8">
          <Active />
        </section>
      </div>
    </div>
  );
}
